<template>
  <div class="vip-detail-order">
    <el-row :gutter="20" class="margin-bottom">
      <el-col :span="24" class="text-right"></el-col>
    </el-row>

    <div class="margin-top">
      <el-table
        :data="vipDetailOrderInfo.orders"
        border
        style="width: 100%"
        v-loading="loading"
      >
        <el-table-column
          prop="cartId"
          :label="$t('vipDetailOrder.orderNo')"
          align="center"
          width="180"
        ></el-table-column>
        <el-table-column
          prop="appName"
          :label="$t('vipDetailOrder.platform')"
          align="center"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="shopName"
          :label="$t('vipDetailOrder.shop')"
          align="center"
          width="150"
        ></el-table-column>
        <el-table-column
          :label="$t('vipDetailOrder.type')"
          align="center"
          width="100"
        >
          <template #default="{row}">
            {{ row.cartType === '3307' ? $t('vipDetailOrder.service') : $t('vipDetailOrder.product') }}
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('vipDetailOrder.name')"
          align="center"
          width="200"
        >
          <template #default="{row}">
            {{ row.cartType === '3307' ? row.prodName : `${row.prodName}(${row.specValue})` }}
          </template>
        </el-table-column>
        <el-table-column
          prop="cartNum"
          :label="$t('vipDetailOrder.quantity')"
          align="center"
          width="100"
        ></el-table-column>
        <el-table-column
          prop="personName"
          :label="$t('vipDetailOrder.userName')"
          align="center"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="payPrice"
          :label="$t('vipDetailOrder.paymentAmount')"
          align="center"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="stateName"
          :label="$t('vipDetailOrder.orderStatus')"
          align="center"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          :label="$t('vipDetailOrder.createTime')"
          align="center"
          width="160"
        ></el-table-column>
      </el-table>

      <el-pagination
        class="margin-top"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { getStoreOrderCart } from '@/api/user/vipDetailApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'VipDetailOrder',
  data() {
    return {
      vipDetailOrderInfo: {
        orders: [],
        link: ''
      },
      loading: false,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      shopId: ''
    }
  },
  created() {
    this.shopId = getShopId()
    console.log(this.shopId)
  },
  methods: {
    open(data) {
      this.vipDetailOrderInfo.link = data.tel
      this.loadOrderData()
    },
    loadOrderData() {
      if (!this.vipDetailOrderInfo.link) return
      
      this.loading = true
      const params = {
        link: this.vipDetailOrderInfo.link,
        shopId: this.shopId,
        page: this.pagination.currentPage,
        row: this.pagination.pageSize
      }

      getStoreOrderCart(params)
        .then(res => {
          this.vipDetailOrderInfo.orders = res.data
          this.pagination.total = res.records
          this.loading = false
        })
        .catch(err => {
          console.error('获取订单数据失败:', err)
          this.loading = false
        })
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadOrderData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadOrderData()
    }
  }
}
</script>

<style scoped>
.vip-detail-order {
  padding: 20px;
}
.margin-bottom {
  margin-bottom: 20px;
}
.margin-top {
  margin-top: 20px;
}
.text-right {
  text-align: right;
}
</style>